import { type ComponentProps } from 'react';

import { cn } from '@air/utils-tailwind';

export const ToastLink = ({ className, ...props }: ComponentProps<'button'>) => (
  <button
    className={cn(
      'line-height-[1.5] inline-block max-w-[200px] truncate font-medium text-14 text-blue-6 hover:text-blue-7 md:max-w-[328px]',
      className,
    )}
    {...props}
  />
);
